import queryParamStore from "@/global/queryParamStore";
import { ROUTE_ACTIONS, ROUTE_ACTIONS_INTERNAL_FLAG } from "./const";
import { hyphenToCamelCase } from "./index";
import smartStorage from "./smart-storage";

export const getAppAction = () => {
  return hyphenToCamelCase(smartStorage.getItem("action")) || "";
};

export const getAppActionProps = () => {
  return smartStorage.getItem("actionProps");
};

export const hasMonthExtensionActionParam = () => {
  const action = getAppAction();
  return (
    action === ROUTE_ACTIONS.TRIAL_UPGRADE_WITH_ONE_MONTH_EXT ||
    queryParamStore.get(ROUTE_ACTIONS_INTERNAL_FLAG.MONTH_EXTENSION)
  );
};
